export default __webpack_public_path__ + "static/media/car-fixing-5.5049cc55.jpg";